/**
 * The tabs of `/admin/courtDetails`, and the rule for which one a given caller
 * actually gets.
 *
 * Extracted from `CourtDetailsPage` so the rule is testable without dragging
 * the whole page (calendar, modals, charts) into a jest module graph.
 */
export enum ViewMode {
  details = 'details',
  calendar = 'calendar',
  configuration = 'configuration',
  pricing = 'pricing',
}

/**
 * `configuration` has no SegmentedControl entry — its option is commented out —
 * so the only way to reach it is by hand-typing `?tab=configuration`, and the
 * page behind it exists to fire `POST courts/:id/configurations`, which the API
 * gates with `hasOrganizationAdminAccess`. A coach who typed the URL therefore
 * got a tab whose only action 403s, with no control rendered as selected.
 *
 * Unknown values and not-for-you values both collapse to `details`: the fallback
 * must not be an oracle for "this tab exists but is not yours".
 */
export function resolveViewMode(
  tabParam: string | null,
  isOrgManager: boolean,
): ViewMode {
  const requested = Object.values(ViewMode).includes(tabParam as ViewMode)
    ? (tabParam as ViewMode)
    : ViewMode.details;

  if (requested === ViewMode.configuration && !isOrgManager) {
    return ViewMode.details;
  }
  return requested;
}
